import axios from '@/axios'

export const getOptions = async (
  endpointUrl,
  params = {},
  keyLabel = 'name',
  keyValue = 'id',
  dataPath = 'data.data',
) => {
  const response = await axios.get(endpointUrl, { params })

  // Helper function to get nested property value
  const getNestedValue = (obj, path) => {
    return path.split('.').reduce((current, key) => {
      return current && current[key] !== undefined ? current[key] : null
    }, obj)
  }

  // Get the data using the specified path
  const data = getNestedValue(response, dataPath)

  // Ensure data is an array
  if (!Array.isArray(data)) {
    throw new Error(`Expected array at path '${dataPath}', but got ${typeof data}`)
  }

  return data.map(option => {
    let textValue;

    if (Array.isArray(keyLabel)) {
      // Find the first non-null/undefined value
      textValue = keyLabel.find(k => option[k] != null)
        ? option[keyLabel.find(k => option[k] != null)]
        : undefined;
    } else {
      textValue = option[keyLabel];
    }

    return {
      text: textValue,
      value: option[keyValue],
      _data: option
    };
  });
}

/**
 * Downloads a file from the server
 * @param {Object} options - Download options
 * @param {string} options.path - Base endpoint path
 * @param {Object} [options.params={}] - URL parameters
 * @param {Object} [options.body={}] - Request body
 * @param {string} [options.fileType] - File type for export functionality
 * @param {boolean} [options.isPrintEndpoint=false] - Whether to use the print endpoint instead of export
 * @returns {Promise<void>}
 */
export async function downloadFile({
  path,
  fileType = 'pdf',
}) {
  try {
    const response = await axios.get(path, {
      responseType: "blob"
    });

    let filename = `file.${fileType}`;
    // Extract filename from Content-Disposition header
    const contentDisposition = response.headers["content-disposition"];
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^"]+)"?/);
      if (match && match[1]) {
        filename = match[1];
      }
    }

    // Create and trigger download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading the file:", error);
  }
}
